import { render, staticRenderFns } from "./BasketItem.vue?vue&type=template&id=2746b78e&scoped=true"
import script from "./BasketItem.vue?vue&type=script&lang=ts"
export * from "./BasketItem.vue?vue&type=script&lang=ts"
import style0 from "./BasketItem.vue?vue&type=style&index=0&id=2746b78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2746b78e",
  null
  
)

export default component.exports